import superMeta from '../_DESIGN/metaDesignNode.mjs'

export default {
    ...superMeta,
    classes: ['product', ...superMeta.classes],
    detailIdProp: '',
    detailUrl: '',
}
